import React, {FC} from 'react';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {PaperProps, TypographyProps, BoxProps, withStyles} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

import {Tooltip} from '..';
import {getDirectionStyles} from '../../utils/ThemeUtils';

import {getAssetPath} from 'epic-diesel-common/src/utils/DieselUtils';

// @ts-ignore
import alertIcon from '../../../../assets/alert-icon.svg';

const useStyles = makeStyles({
    customWidth: {
        maxWidth: 350
    }
});

const StyledTypography = withStyles<string, undefined, TypographyProps>(theme => ({
    root: {
        color: theme.palette.warning.light
    }
}))(Typography);

const StyledTooltipContent = withStyles<string, undefined, PaperProps>(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: '285px',
        marginTop: theme.spacing(2),
        padding: theme.spacing(3, 4),
        backgroundColor: theme.palette.background.paper
    }
}))(Paper);

const StyledIcon = withStyles<string, undefined, BoxProps>(theme => ({
    root: {
        paddingBottom: theme.spacing(4),
        padding: getDirectionStyles(theme.direction)(
            theme.spacing(0, 0, 0, 1),
            theme.spacing(0, 1, 0, 0)
        )
    }
}))(Box);

const StyledDescription = withStyles<string, undefined, BoxProps>(theme => ({
    root: {
        margin: getDirectionStyles(theme.direction)(
            theme.spacing(0, 1, 0, 4),
            theme.spacing(0, 4, 0, 1)
        )
    }
}))(Box);

export interface DataUnavailableTooltipProps {
    title: string;
    description: string;
}

const DataUnavailableTooltip: FC<DataUnavailableTooltipProps> = ({
    title,
    description
}: DataUnavailableTooltipProps) => {
    const classes = useStyles();

    return (
        <Tooltip
            placement="top"
            title={
                <>
                    <Typography variant="caption" color="textPrimary">
                        {title}
                    </Typography>
                    <StyledTooltipContent elevation={0}>
                        {/* @ts-ignore */}
                        <StyledIcon component="img" src={getAssetPath(alertIcon)} />
                        <StyledDescription>
                            <StyledTypography variant="caption">{description}</StyledTypography>
                        </StyledDescription>
                    </StyledTooltipContent>
                </>
            }
            classes={{tooltip: classes.customWidth}}>
            <Box height={16} mx={1}>
                {/* @ts-ignore */}
                <Box component="img" src={getAssetPath(alertIcon)} />
            </Box>
        </Tooltip>
    );
};

export default DataUnavailableTooltip;
